import classnames from 'classnames';
import { Tabs, Tab, Chip, Image } from '@ds';
import { UnosIdButton } from '@ui';
import { getCardDateTime } from '@features/components/CaseCard/utils';
import { atTxCenterStatuses } from '@features/components/CaseCard/constants';
import { Case } from '@/api/apis/case';
import { getCaseSuffixes, getColorsByOrganType, getOrganImg } from '@/utils/helpers';

export enum CompareViewTypeEnum {
  RouteList = 'RouteList',
  RouteSchema = 'RouteSchema',
}

type CompareTopBarProps = {
  caseData: Case;
  viewType: CompareViewTypeEnum;
  onViewTypeChange: (viewType: CompareViewTypeEnum) => void;
};

export const CompareTopBar = ({ caseData, viewType, onViewTypeChange }: CompareTopBarProps) => {
  const {
    donorId,
    organType,
    donorType,
    reAllocationSequenceNumber,
    opoRequest,
    isExpeditedCase,
    status,
    laterality,
    duplicateCaseNumber,
  } = caseData;

  const colors = getColorsByOrganType(organType);
  const dateValue = getCardDateTime(caseData);
  const caseSuffixes = getCaseSuffixes(
    organType,
    reAllocationSequenceNumber,
    opoRequest,
    isExpeditedCase,
    laterality,
    duplicateCaseNumber,
  );

  return (
    <div className="w-full flex items-center justify-between">
      <div className="flex gap-6 items-center">
        <div className="flex items-center gap-2">
          <UnosIdButton
            suffixColor={colors.textDefault}
            donorId={donorId}
            caseSuffixes={caseSuffixes}
            onDonorIdClick={(e) => e.stopPropagation()}
            containerClassName="text-[22px]"
          />
          <div className="flex">
            <Chip className={classnames('flex justify-center h-6', colors.bg50)}>{donorType ?? '-'}</Chip>
            <div className={classnames('-ml-1.5 size-6 flex items-center justify-center rounded-full', colors.bg50)}>
              <Image src={getOrganImg(organType)} alt={`${organType} image`} />
            </div>
          </div>
        </div>
        <div className="flex gap-2">
          <span className="text-s-r truncate">
            {atTxCenterStatuses.includes(status) ? 'ETA At Tx Center:' : 'Donor OR:'}
          </span>
          <span className="text-s-sb truncate">{dateValue}</span>
        </div>
      </div>
      <Tabs
        selectedKey={viewType}
        onSelectionChange={(key) => onViewTypeChange(key as CompareViewTypeEnum)}
        classNames={{
          tabList: 'bg-base-50 gap-0 w-full relative rounded-full p-0',
          cursor: 'w-full bg-base-5 rounded-full',
          tab: 'max-w-fit min-w-38 p-3',
          tabContent: 'text-s-sb text-base-5 group-data-[selected=true]:text-base-90',
        }}
      >
        <Tab key={CompareViewTypeEnum.RouteList} title="Trip Plan" />
        <Tab key={CompareViewTypeEnum.RouteSchema} title="Schema" />
      </Tabs>
    </div>
  );
};
